import { render, staticRenderFns } from "./PlantVarietyHistoryForm.vue?vue&type=template&id=e2b35200&"
import script from "./PlantVarietyHistoryForm.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyHistoryForm.vue?vue&type=style&index=0&id=e2b35200&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports